import {createIcon} from '@chakra-ui/icon';

export const Logo = createIcon({
  displayName: 'Logo',
  viewBox: '0 0 324.21 69.5',
  path: (
    <svg>
      <defs>
        <linearGradient
          id={'logo-linear-gradient'}
          x1={'116.73'}
          y1={'75.13'}
          x2={'365.44'}
          y2={'141.77'}
          gradientUnits={'userSpaceOnUse'}
        >
          <stop offset={'0'} stopColor={'#ef4237'} />
          <stop offset={'0.27'} stopColor={'#ef4237'} />
          <stop offset={'0.41'} stopColor={'#da3f45'} />
          <stop offset={'0.7'} stopColor={'#a43868'} />
          <stop offset={'1'} stopColor={'#67308f'} />
        </linearGradient>
      </defs>
      <title>{'Klearly Logo'}</title>
      <circle
        className={'c-logo__period'}
        cx={'378.02'}
        cy={'124.84'}
        r={'6.61'}
        transform={'translate(-62.52 -70.65) rotate(-0.99)'}
      />
      <circle
        className={'c-logo__dot'}
        opacity={'0.85'}
        cx={'99.64'}
        cy={'102.6'}
        r={'8.37'}
        transform={'translate(-69.4 -67.67) rotate(-5.26)'}
      />
      <circle
        className={'c-logo__dot'}
        opacity={'0.7'}
        cx={'87.68'}
        cy={'89.13'}
        r={'4.09'}
        transform={'translate(-71.72 -64.48) rotate(-7.81)'}
      />
      <circle
        className={'c-logo__dot'}
        opacity={'0.25'}
        cx={'63.77'}
        cy={'110.72'}
        r={'3.35'}
        transform={'translate(-74.88 -67.53) rotate(-7.82)'}
      />
      <circle
        className={'c-logo__dot'}
        opacity={'0.35'}
        cx={'70.38'}
        cy={'84.35'}
        r={'4.18'}
        transform={'translate(-61.87 -76) rotate(-0.99)'}
      />
      <circle
        className={'c-logo__dot'}
        opacity={'0.9'}
        cx={'106.41'}
        cy={'82.88'}
        r={'5.65'}
        transform={'translate(-75.64 -52.63) rotate(-12.31)'}
      />
      <circle
        className={'c-logo__dot'}
        cx={'106.41'}
        cy={'124.85'}
        r={'6.41'}
        transform={'translate(-62.56 -75.37) rotate(-0.99)'}
      />
      <circle
        className={'c-logo__dot'}
        opacity={'0.6'}
        cx={'84.6'}
        cy={'116.16'}
        r={'6.94'}
        transform={'translate(-70.7 -68.99) rotate(-5.26)'}
      />
      <circle
        className={'c-logo__dot'}
        opacity={'0.6'}
        cx={'79.3'}
        cy={'129.07'}
        r={'2.77'}
        transform={'translate(-62.64 -75.84) rotate(-1)'}
      />
      <circle
        className={'c-logo__dot'}
        opacity={'0.45'}
        cx={'74.57'}
        cy={'96.55'}
        r={'3.24'}
        transform={'translate(-62.08 -75.92) rotate(-0.99)'}
      />
      <path
        className={'c-logo__words'}
        fill={'url(#logo-linear-gradient)'}
        d={
          'M171.1,131.46H154.85A1,1,0,0,1,154,131l-11.3-17.79A1,1,0,0,0,141,113l-4.68,5.16a1,1,0,0,0-.27.7v11.5a1,1,0,0,1-1,1h-11.8a1,1,0,0,1-1-1v-5.19a9.23,9.23,0,0,1,0-18.12v-3.6a7.16,7.16,0,1,1,0-11.79v-12a1,1,0,0,1,1-1H135a1,1,0,0,1,1,1V97a1,1,0,0,0,1.84.67l15.53-18.58a1,1,0,0,1,.8-.37h15.24a1,1,0,0,1,.78,1.74l-17.1,19a1,1,0,0,0-.1,1.26L172,129.84A1,1,0,0,1,171.1,131.46ZM176,78.68h13.12a1,1,0,0,1,1,1V130.4a1,1,0,0,1-1,1H176a1,1,0,0,1-1-1V79.72A1,1,0,0,1,176,78.68ZM230.58,96q-5.65-6-15.73-6a23.45,23.45,0,0,0-11.29,2.63A18.82,18.82,0,0,0,196,100a22.14,22.14,0,0,0-2.71,11.1,21.77,21.77,0,0,0,2.67,11,18.32,18.32,0,0,0,7.64,7.3A25,25,0,0,0,215.3,132a27.25,27.25,0,0,0,10.35-1.88,21.09,21.09,0,0,0,7.15-4.74,1.05,1.05,0,0,0,0-1.48l-6.49-6.36a1,1,0,0,0-1.4,0,12.87,12.87,0,0,1-8.31,3.28,8,8,0,0,1-5-1.58,8.09,8.09,0,0,1-2.39-3,1.06,1.06,0,0,1,.95-1.52h25a1.06,1.06,0,0,0,1.12-1c0-.41,0-.73,0-1.3Q236.23,101.94,230.58,96Zm-10.5,11.25H209.63a1.06,1.06,0,0,1-1-1.38,9.21,9.21,0,0,1,2-3.66,5.68,5.68,0,0,1,4.36-1.88,5.75,5.75,0,0,1,4.52,2,6.6,6.6,0,0,1,1.61,3.78A1.06,1.06,0,0,1,220.08,107.21ZM273,93.85q-4.85-4-13.51-4a51.8,51.8,0,0,0-18.75,3.83,1.06,1.06,0,0,0-.61,1.35l3,8.12a1,1,0,0,0,1.36.59,37.75,37.75,0,0,1,5.6-1.77,26.21,26.21,0,0,1,5.76-.75,8.36,8.36,0,0,1,5.27,1.43,4.81,4.81,0,0,1,1.81,4v.15h-10q-7.75.07-11.78,3.27t-4,9.15a12.31,12.31,0,0,0,3.69,9.37q3.69,3.5,10.16,3.5a17.18,17.18,0,0,0,7-1.36,12.32,12.32,0,0,0,4.93-3.84v3.47a1,1,0,0,0,1,1h12.82a1,1,0,0,0,1-1V104.87Q277.86,97.8,273,93.85ZM263,117.73a1.12,1.12,0,0,1-.1.47,6.47,6.47,0,0,1-2.61,2.86,8,8,0,0,1-4.22,1.13,5,5,0,0,1-3.39-1.05,3.78,3.78,0,0,1-1.2-3q0-3.84,4.59-3.84h5.88a1,1,0,0,1,1,1Zm40.61-26a14.52,14.52,0,0,1,6.33-1.81A1,1,0,0,1,311,91v11.47c0,.8-.71,1.05-1.33,1-.39,0-.82,0-1.3,0a11.45,11.45,0,0,0-7.49,2.26,7.56,7.56,0,0,0-2.75,6.17V130.4a1,1,0,0,1-1,1H283.95a1,1,0,0,1-1-1V91.54a1,1,0,0,1,1-1h13.12a1,1,0,0,1,1,1v2.39a1,1,0,0,0,1.79.71A15,15,0,0,1,303.57,91.74Zm12.67-13.06h13.12a1,1,0,0,1,1,1V130.4a1,1,0,0,1-1,1H316.24a1,1,0,0,1-1-1V79.72A1,1,0,0,1,316.24,78.68Zm39.31,65.15a17.91,17.91,0,0,1-10.39,2.9,21.13,21.13,0,0,1-6.93-1.09,22,22,0,0,1-5.45-2.85,1.05,1.05,0,0,1-.28-1.41l5.18-8.33a1,1,0,0,1,1.5-.28,8.38,8.38,0,0,0,1.84,1.08,7.27,7.27,0,0,0,2.79.53,4.53,4.53,0,0,0,4.44-2.63l.75-1.43L332.68,91.95a1,1,0,0,1,1-1.45h13.27a1,1,0,0,1,1,.69l7.65,21.4a1,1,0,0,0,2,0L364,91.24a1,1,0,0,1,1-.74h12.84a1,1,0,0,1,1,1.42l-16.62,43A19,19,0,0,1,355.55,143.83Z'
        }
        transform={'translate(-60.41 -77.23)'}
      />
    </svg>
  ),
});
